/** Espace client V2 — références mockups validés Carlos (juin 2026). Pas de blocs garantie générique. */

export const CLIENT_PORTAL_V2 = {
  bg: '#0f1117',
  panel: '#151820',
  accent: '#dc2626',
  accentSoft: 'rgba(220, 38, 38, 0.15)',
  border: 'rgba(255, 255, 255, 0.1)',
};

export const CLIENT_PORTAL_HEROES = {
  reparations: {
    image: '/mockups/client-portal-v2/mockup-client-reparations.png',
    kicker: 'Suivi en temps réel',
    title: 'Suivi de vos réparations',
    subtitle: 'Retrouvez ici l\'état d\'avancement de vos réparations en cours et l\'historique de vos appareils.',
  },
  boutique: {
    image: '/mockups/client-portal-v2/mockup-client-boutique.png',
    kicker: 'La boutique R.E.Mobiles',
    title: 'Accessoires essentiels pour votre mobile',
    subtitle: 'Protégez, chargez, optimisez — sélection testée par nos experts.',
  },
  commandes: {
    image: '/mockups/client-portal-v2/mockup-client-commandes.png',
    kicker: 'Suivi de livraison',
    title: 'Vos commandes en un coup d\'œil',
    subtitle: 'Historique, statut et preuve de paiement pour chaque commande.',
  },
  devis: {
    image: '/mockups/client-portal-v2/mockup-client-devis-factures.png',
    kicker: 'Vos documents',
    title: 'Devis et factures',
    subtitle: 'Consultez, téléchargez et validez vos documents en toute simplicité.',
  },
};

/** Bandeau confiance boutique — sans mention garantie automatique. */
export const BOUTIQUE_TRUST_ITEMS = [
  { label: 'Produits de qualité', desc: 'Sélection magasin' },
  { label: 'Expédition rapide', desc: 'Sous 24–48 h' },
  { label: 'Paiement sécurisé', desc: 'CB · Stripe' },
  { label: 'SAV réactif', desc: 'Support en magasin' },
];
